import type { PropsWithChildren } from 'react'

type LayoutMainProps = PropsWithChildren

export const LayoutMain = ({ children }: LayoutMainProps) => {
  return (
    <div className="flex h-svh overflow-hidden bg-background">{children}</div>
  )
}
